import React, { useEffect, useState } from "react";

// eslint-disable-next-line no-unused-vars
import { format } from "date-fns";
import { useHistory } from "react-router-dom";
import * as XLSX from 'xlsx'; 
import MyTable from "components/Table/Table";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { DeleteOutlined } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Modal from "@Components/Modal";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import ExcelLogo from "assets/img/excelred_icon.svg";

import eightAxios from "configs/axiosConfig";
import LoadingIcon from "components/LoadingIcon/LoadingIcon";
import { getAssignedModule, isObjectEmpty, removeAllInstances } from "utils";
import Error from "views/Error/Error";
import ConfirmDialog from "@Components/ConfirmDialog";
import ViewDialog from "@Components/ViewDialog";
import FileDownload from "js-file-download";
import { useNotifyContext } from "@Components/Notify";
import { useTranslation } from "react-i18next";
import PropTypes, { object } from "prop-types";
import { useInterval } from "utils";
import {
  STORAGE_CONSTANT,
  USER_STATUS,
  ROLE_STATUS,
  BANNER_URL,
  BO_USER_STATUS,
  WORKER_CONTRACT_URL,
  ATTENDANCE_BY_MONTH_URL,
} from "configs/constants";
import LinearProgress from "@material-ui/core/LinearProgress";
import { IconButton } from "@material-ui/core";
import { WORKER_DETAILED_REPORT_URL } from "configs/constants";
import { BO_ACCESS_MOBILE_REPORT_URL } from "configs/constants";
import { BO_ACCESS_PORTAL_REPORT_URL } from "configs/constants";
import { POLICY_DETAILS_URL } from "configs/constants";
import { HQVIEW_URL } from "configs/constants";
import { SHOP_URL } from "configs/constants";

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';


const Table = (props) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [onError, setOnError] = useState({});
  const [loading, setLoading] = useState(false);
  const [doPolling, setDoPolling] = useState(false);
  const [sorter, setSorter] = useState(null);
  const [excelConfig, setExcelConfig] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [messageBody, setMessageBody] = useState();

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [viewDialog, setViewDialog] = useState({
    isOpen: false,
    title: "",
    imageUrl: "",
    viewTitle: "",
    imageTitle: "",
  });

  const [modalFields, setModalFields, inputEmail] = useState({
    batch: false,
    isOpen: false,
    body: null,
    inputEmail: true,
    onConfirm: null,
    decline: false,
    resetModalBodyState: () => setErrorMessage(""),
  });
  const setNotify = useNotifyContext();
  const pollingInterval = 5000;
  // States and handler for check-boxes start here
  // allChecked is a state for table header, used to check all
  const [allChecked, setAllChecked] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const history = useHistory();

  let config;

  config = {
    params: {
      page: page + 1,
      page_size: pageSize,
      from_frontend: true,
    },
  };


  const {
    proxyURL,
    model,
    paginationDisable,
    tableBodyDisable,
    actions,
    filters,
    excelExport,
    pdfExport,
    disablePdfExport,
    disableExcelExport,
    emailExcelExport,
    showInfoIcon,
    infoContent,
    noFilter,
    noAddButton,
    actionBarButtons,
    check,
    selected,
    setSelected,
    selectedEmployeeId,
    setSelectedEmployeeId,
    filterValues,
    defaultFilterParams,
    isBackOffice,
    polling,
    outerFetchTrigger,
    linkUrlName,
    isUserDelete,
    isBOUserDelete,
    isRoleDelete,
    isLanguageDelete,
    isBannerDelete,
    isShopDelete,
    refresh,
    setTableData,
    downloadId,
    pageNumberDropdown,
    hideToolbar,
    noData,
    grandTotalEnable,
    disableLabelDisplayedRows,

  } = props;


  const [shortTermMemory, setShortTermMemory] = useState(
    downloadId ? downloadId : []
  );

  useEffect(() => {
    if (downloadId) {
      setShortTermMemory(downloadId);
    }
  }, [downloadId]);

  /**
   *   Main code to check the permission/s starts here
   */

  let module = getAssignedModule(location.pathname);
  let viewPermission = false;
  let addPermission = false;
  let viewDetailsPermission = false;
  let editPermission = false;
  let downloadPermission = false;
  let deletePermission = false;
  let emailDownloadPermission = false;

  if (!module || module === "") {
    viewPermission = true;
    viewDetailsPermission = true;
    addPermission = true;
    editPermission = true;
    downloadPermission = true;
    emailDownloadPermission = true;
    deletePermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("view details")) {
        viewDetailsPermission = true;
      }
      if (modulePermissions.includes("view")) {
        viewPermission = true;
      }

      if (modulePermissions.includes("edit")) {
        editPermission = true;
      }
      if (modulePermissions.includes("add")) {
        addPermission = true;
      }
      if (modulePermissions.includes("delete")) {
        deletePermission = true;
      }
      if (modulePermissions.includes("download")) {
        downloadPermission = true;
        emailDownloadPermission = true;

      }

    }
  }

  /**
   *   Main code (block) to check the permission/s ends here
   *   There still are few snippets below controlling the permission/s
   */

  if (isBackOffice) {
    Object.assign(config.params, { is_back_office: isBackOffice });
  }

  if (defaultFilterParams) {
    Object.assign(config.params, {
      date: defaultFilterParams.params.from_date,
    });

    Object.assign(config.params, { date: defaultFilterParams.params.to_date });
    Object.assign(config.params, { status: defaultFilterParams.params.status });
  }

  const handleAllChecked = () => {
    if (allChecked) {
      setSelected([]);
      setAllChecked(!allChecked);
    } else {
      setSelected(["all"]);
      setAllChecked(!allChecked);
    }
  };
  const handleEmployeeId = (id) => {
    if (selectedEmployeeId.includes(id)) {
      let temp = selectedEmployeeId;
      let index = temp.indexOf(id);
      if (index !== -1) {
        temp.splice(index, 1);
        setSelectedEmployeeId(temp);
      }
    } else {
      let temp = selectedEmployeeId;
      temp.push(id);
      setSelectedEmployeeId(temp);
    }
  };

  const handleSelected = (id) => {
    if (selected.includes("all")) {
      let tempData = [...selected, ...data.map((_data) => _data.id)];
      tempData = tempData.filter((data) => data !== "all" && data !== id);
      setAllChecked(!allChecked);
      setSelected(tempData);
    } else if (selected.includes(id)) {
      let temp = selected;
      let index = temp.indexOf(id);
      if (index !== -1) {
        temp.splice(index, 1);
        setSelected(temp);
      }
    } else {
      let temp = selected;
      temp.push(id);
      setSelected(temp);
    }
  };
  // States and handler for check-boxes end here

  // Arguments to pass onto MyTable component
  const [checkBoxArgs, setCheckBoxArgs] = useState(
    check
      ? {
        headCheckBox: allChecked,
        headCheckBoxCallback: handleAllChecked,
        checkBox: selected,
        checkBoxCallback: handleSelected,
        EmployeSelectCallback: handleEmployeeId
      }
      : null
  );
  useEffect(() => {
    if (check) {
      setCheckBoxArgs({});
      setCheckBoxArgs({
        headCheckBox: allChecked,
        headCheckBoxCallback: handleAllChecked,
        checkBox: selected,
        checkBoxCallback: handleSelected,
        EmployeSelectCallback: handleEmployeeId
      });
    }
  }, [check, allChecked, selected]);
  // Arguments ends here

  let allActions = [];
  let allFilters = [];
  let allActionBarButtons = [];
  const downloadLedger = (id) => {


    eightAxios.get(BANNER_URL + "export/?id=" + id + "&email=" + JSON.parse(localStorage.getItem('email')))
      .then((response) => {

        setNotify({
          isOpen: true,
          message: response.data.message,
          type: "success",
        });
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
      });
  };

  const onDelete = (id) => {
    if (isRoleDelete) {
      setLoading(true);
      eightAxios.get(ROLE_STATUS + id).then((response) => {
        setLoading(false);
        console.log(response.status);
        if (response.status === 200) {
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: "error",
          });
        }
        else if (response.status === 202) {
          eightAxios
            .delete(`${proxyURL}${id}/`)
            .then(() => {
              setData(data.filter((item) => item.id !== id));
              setConfirmDialog({
                ...confirmDialog,
                isOpen: false,
              });
              setNotify({
                isOpen: true,
                message: t("Record Deleted Successfully"),
                type: "success",
              });
            })
            .catch(() => {
              setNotify({
                isOpen: true,
                message: t("Failed to delete the record"),
                type: "error",
              });
            });
        } else {
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          setNotify({
            isOpen: true,
            message: t("Cannot Delete. Already tagged."),
            type: "error",
          });
        }
      }).catch((error) => {
        setLoading(false);
        setConfirmDialog({
          ...confirmDialog,
          isOpen: false,
        });
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
      });


    }
    else if (isBannerDelete) {
      setLoading(true);
      eightAxios.delete(BANNER_URL + "delete/?id=" + id).then((response) => {
        setLoading(false);
        console.log(response.status);
        if (response.status === 200) {
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          setNotify({
            isOpen: true,
            // message: response.data.message,
            message : "Banner is deleted successfully",
            type: "success",
          });
          window.location.reload();


        } else if (response.status === 202) {
          eightAxios
            .delete(`${proxyURL}${id}/`)
            .then(() => {
              setData(data.filter((item) => item.id !== id));
              setConfirmDialog({
                ...confirmDialog,
                isOpen: false,
              });
              setNotify({
                isOpen: true,
                message: t("Record Deleted Successfully"),
                type: "success",
              });
            })
            .catch(() => {
              setNotify({
                isOpen: true,
                message: t("Failed to delete the record"),
                type: "error",
              });
            });
        } else {
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          setNotify({
            isOpen: true,
            message: t("Cannot Delete. Already tagged."),
            type: "error",
          });
        }
      });
    }
    else if (isShopDelete) {
      setLoading(true);
      eightAxios.delete(SHOP_URL + id).then((response) => {
        setLoading(false);
        console.log(response.status);
        if(response.status === 204){
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          
          setNotify({
            isOpen: true,
            message: 'Shop has been successfully deleted',
            type: 'success',
          });
        }
        
        else if (response.status === 202) {
          eightAxios
            .delete(`${proxyURL}${id}/`)
            .then(() => {
              setData(data.filter((item) => item.id !== id));
              setConfirmDialog({
                ...confirmDialog,
                isOpen: false,
              });
              setNotify({
                isOpen: true,
                message: t("Record Deleted Successfully"),
                type: "success",
              });
            })
            .catch(() => {
              setNotify({
                isOpen: true,
                message: t("Failed to delete the record"),
                type: "error",
              });
            });
        } else {
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          setNotify({
            isOpen: true,
            message: t("Cannot Delete. Already tagged."),
            type: "error",
          });
        }
      });
    }
    else if (isLanguageDelete) {
      setLoading(true);
      eightAxios.get(WORKER_CONTRACT_URL + id + "/").then((response) => {
        setLoading(false);
        console.log(response.status);
        if (response.status === 200) {
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: "error",
          });
        } else if (response.status === 202) {
          eightAxios
            .delete(`${proxyURL}${id}/`)
            .then(() => {
              setData(data.filter((item) => item.id !== id));
              setConfirmDialog({
                ...confirmDialog,
                isOpen: false,
              });
              setNotify({
                isOpen: true,
                message: t("Record Deleted Successfully"),
                type: "success",
              });
            })
            .catch(() => {
              setNotify({
                isOpen: true,
                message: t("Failed to delete the record"),
                type: "error",
              });
            });
        } else {
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          setNotify({
            isOpen: true,
            message: t("Cannot Delete. Already tagged."),
            type: "error",
          });
        }
      });
    }
    else if (isUserDelete) {
      setLoading(true);
       /* eightAxios
        .get(USER_STATUS + id + "/")
        .then((response) => {
          setLoading(false);
          if (response.status === 200) {
            setConfirmDialog({
              ...confirmDialog,
              isOpen: false,
            });
            setNotify({
              isOpen: true,
              message: "Cannot Delete." + response.data.message,
              type: "error",
            });
          }
          if (response.status === 202) {
            eightAxios
              .delete(`${proxyURL}${id}/`)
              .then(() => {
                setData(data.filter((item) => item.id !== id));
                setConfirmDialog({
                  ...confirmDialog,
                  isOpen: false,
                });
                setNotify({
                  isOpen: true,
                  message: "Record Deleted Successfully",
                  type: "success",
                });
              })
              .catch(() => {
                setNotify({
                  isOpen: true,
                  message: "Failed to delete the record",
                  type: "error",
                });
              });
          }
        })
        .catch((error) => {
          setOnError({
            code: 403,
            message: error.message,
            sidebar: false,
          });
          setLoading(false);
        });  */

        eightAxios
              .delete(`${proxyURL}${id}/`)
              .then(() => {
                setLoading(false);
                setData(data.filter((item) => item.id !== id));
                setConfirmDialog({
                  ...confirmDialog,
                  isOpen: false,
                });
                setNotify({
                  isOpen: true,
                  message: "Record Deleted Successfully",
                  type: "success",
                });
              })
              .catch((error) => {
                setNotify({
                  isOpen: true,
                  message: error.response.data.message,
                  type: "error",
                });
                setLoading(false);
              });

        /* eightAxios
              .delete(`${proxyURL}${id}/`)
              .then(() => {
                setData(data.filter((item) => item.id !== id));
                setConfirmDialog({
                  ...confirmDialog,
                  isOpen: false,
                });
                setNotify({
                  isOpen: true,
                  message: "Record Deleted Successfully",
                  type: "success",
                });
              })
              .catch((error) => {
                setNotify({
                  isOpen: true,
                  message: error.response.data.message,
                  type: "error",
                });
              });
              setLoading(false);  */


    } else if (isBOUserDelete) {
      setLoading(true);
       eightAxios
        .get(BO_USER_STATUS + id + "/")
        .then((response) => {
          setLoading(false);
          if (response.status === 200) {
            setConfirmDialog({
              ...confirmDialog,
              isOpen: false,
            });
            setNotify({
              isOpen: true,
              message: "Cannot Delete." + response.data.message,
              type: "error",
            });
          }
          if (response.status === 202) {
            eightAxios
              .delete(`${proxyURL}${id}/`)
              .then(() => {
                setData(data.filter((item) => item.id !== id));
                setConfirmDialog({
                  ...confirmDialog,
                  isOpen: false,
                });
                setNotify({
                  isOpen: true,
                  message: "Record Deleted Successfully",
                  type: "success",
                });
              })
              .catch(() => {
                setNotify({
                  isOpen: true,
                  message: "Failed to delete the record",
                  type: "error",
                });
              });
          }
        })
        .catch((error) => {
          setOnError({
            code: 403,
            message: error.message,
            sidebar: false,
          });
          setLoading(false);
        }); 

        /* eightAxios
              .delete(`${proxyURL}${id}/`)
              .then((response) => {
                setData(data.filter((item) => item.id !== id));
                setConfirmDialog({
                  ...confirmDialog,
                  isOpen: false,
                });
                setNotify({
                  isOpen: true,
                  message: "Record Deleted Successfully",
                  type: "success",
                });
              })
              .catch((error) => {  

                setNotify({
                  isOpen: true,
                  message:error.response.data.message,
                  type: "error",
                });
              });

              setLoading(false);  */
    }

    else {
      const newProxyURL = proxyURL.replace("bo-list/", "");
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });
      eightAxios
        .delete(`${newProxyURL}${id}/`)
        .then((response) => {
          setData(data.filter((item) => item.id !== id));
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: "success",
          });
        })
        .catch((response) => {
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: "error",
          });
        });
    }
  };

  const onView = (id) => {
    setLoading(true);
    eightAxios.get(`${proxyURL}${id}/`).then((response) => {
      setViewDialog({
        isOpen: true,
        imageTitle: t("Estate QR code"),
        imageUrl: response.data.qr_url,
        viewTitle: t("ESTATE QR CODE"),
      });
    });
  };
  const styles = {
    iconButton: {
      padding: 0,
    },
  };
  const builtInActions = {
    edit: {
      type: "edit",
      title: "Edit",
      icon: <EditOutlinedIcon />,
      color: "secondary",
      onClick: (id) => history.push(`${history.location.pathname}/edit/${id}`),
    },
    delete: {
      type: "delete",
      title: "Delete",
      icon: <DeleteOutlined />,
      color: "secondary",
      onClick: (id) => onDelete(id),
    },
    view: {
      type: "view",
      title: "View",
      icon: <VisibilityIcon />,
      color: "secondary",
      onClick: (id) => onView(id),
    },

    download: {
      type: "download",
      title: "Download",
      icon: <IconButton style={styles.iconButton}>

        <img src={ExcelLogo} alt="excel_icon" />
      </IconButton>,
      onClick: (id, record) => downloadLedger(id, record),
    },


  };

  // eslint-disable-next-line no-unused-vars
  const doFilter = (values, setLoading) => {
    if (!isObjectEmpty(values)) {
      Object.assign(config.params, values);
    }
    fetchData(config);
  };

  const getActions = () => {
    allActions = [];
    let modifiedActions = actions;
    /**
     *     Control the actions to display depending upon their permissions
     */
    if (actions) {
      if (!deletePermission && actions.includes("delete")) {
        removeAllInstances(modifiedActions, "delete");
      }
      if (!editPermission && actions.includes("edit")) {
        removeAllInstances(modifiedActions, "edit");
      }
      if (!viewPermission && actions.includes("view")) {
        removeAllInstances(modifiedActions, "view");
      }
      if (!downloadPermission && actions.includes("download")) {
        removeAllInstances(modifiedActions, "download");
      }

      modifiedActions.forEach((action) => {
        if (typeof action === "string") {
          allActions.push(builtInActions[action]);
        } else allActions.push(action);
      });
    }
  };

  const getActionBarButtons = () => {
    allActionBarButtons = [];

    if (actionBarButtons) {
      actionBarButtons.forEach((action) => {
        allActionBarButtons.push(action);
      });
    }

    if (!noAddButton) {
      /**
       * Check add permission
       */
      if (addPermission) {
        allActionBarButtons.push({
          color: "primary",
          buttonLabel: t("Add"),
          startIcon: <AddIcon />,
          onClick: () => history.push(`${history.location.pathname}/add`),
        });
      }
    }
  };

  const getFilters = () => {
    allFilters = model.map((item) => {
      let filter = {};
      // if (filters.hasOwnProperty(item.id)) {
      if (item.id === "actions") return false;
      if (filters && item.id in filters) {
        filter = filters[item.id];
        filter["apiCall"] = (values, setLoading) =>
          doFilter(values, setLoading);
      } else {
        if (noFilter) {
          return false;
        } else {
          filter = {
            name: item.id,
            type: "input",
            apiKey: item.id,
            apiCall: (values, setLoading) => doFilter(values, setLoading),
          };
        }
      }
      return filter;
    });
    allFilters = allFilters.filter((item) => item !== false);

  };

  const mapData = (result) => {
    return result?.map((row) => {
      let single_data = {
        id: row.id,
      };
      model.forEach((item) => {
        if (item.type === "boolean") {
          if (item.yesValue && item.noValue) {
            single_data[item.id] = row[item.id] ? item.yesValue : item.noValue;
          } else {
            single_data[item.id] = row[item.id] ? "Yes" : "No";
          }
        }
        else if (item.type === "boolean_status") {
          if (item.yesValue && item.noValue) {
            single_data[item.id] = row[item.id] ? item.yesValue : item.noValue;
          } else {
            single_data[item.id] = row[item.id] ? "Active" : "Inactive";
          }
        }

        else if (item.type === "date_time") {
           /* single_data[item.id] = format(
            Date.parse(row[item.id]),
            "dd/MM/yyyy h:mm:ss a"
          );  */
           let tempTime = new Date(row[item.id]);
          single_data[item.id] = tempTime.toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              hour12: true,
              timeZone: 'Asia/Singapore'
          }); 
        }
        else if (item.type === "date_time_origin") {
          single_data[item.id] = format(
           Date.parse(row[item.id]),
           "dd/MM/yyyy h:mm:ss a"
         ); 
         /* let tempTime = new Date(row[item.id]);
         single_data[item.id] = tempTime.toLocaleString("en-GB", {
             year: "numeric",
             month: "numeric",
             day: "numeric",
             hour: "numeric",
             minute: "numeric",
             hour12: true,
             timeZone: 'Asia/Singapore'
         }); */
       }
        else if (item.type === "date") {
          try {
            let tempDate = new Date(row[item.id]);
            single_data[item.id] = tempDate.toLocaleDateString("en-GB");
          } catch (e) {
            single_data[item.id] = row[item.id];
          }
        }
        else if (item.type === "time") {
          try {
            let tempTime = new Date(row[item.id]);
            single_data[item.id] = tempTime.toLocaleTimeString("en-GB", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
              timeZone: 'Asia/Singapore',

            });
          } catch (e) {
            single_data[item.id] = row[item.id];
          }
        }
        else if (item.type === "datetime") {
          try {
            let tempDateTime = new Date(row[item.id]);
            single_data[item.id] = tempDateTime.toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              hour12: true,
              timeZone: 'Asia/Singapore',
            });
          } catch (e) {
            single_data[item.id] = row[item.id];
          }
        }



        else if (item.type === "loading") {
          if (
            (shortTermMemory.length && shortTermMemory.includes(row.id)) ||
            shortTermMemory.includes("all")
          ) {
            single_data[item.id] = <LinearProgress />;
          } else {
            single_data[item.id] = row[item.id];
          }
        }
        else if (item.type === "objectname") {
          const name = row[item.id]?.name ?? "N/A";
          single_data[item.id] = name;
        }

        else if (item.type === "object") {
          single_data[item.id] = JSON.stringify(row[item.id]);
        } else single_data[item.id] = row[item.id];
      });
      return single_data;
    });

  };

  useEffect(() => {
    const initialPage = 0;
    setPage(initialPage);
    config.params.page = initialPage + 1;
  }, [filterValues]);

  const fetchData = (config) => {
    if (!isObjectEmpty(filterValues)) {
      Object.assign(config.params, filterValues);
    }
    if (proxyURL === HQVIEW_URL) {
      config.params.hq = true;
    }
    if (!proxyURL) {
      setData([]);
    }
    else {
      setExcelConfig(config);
      setLoading(true);
      eightAxios
        .get(proxyURL, config)
        .then((response) => {
          if (response.status === 200) {
            if (proxyURL == WORKER_DETAILED_REPORT_URL) {
              setData([]);
              setLoading(false);
              return;
            }
          
            let results = mapData(response.data.results)
        /*     const baseURL = eightAxios.defaults.baseURL

          
            if (baseURL && baseURL.startsWith("https://uatewalletapi.fgvholdings.com/api/v1/")) {
              results = results.map(record => {
                const dateTime = new Date(`${record.date}T${record.time}`)
                dateTime.setHours(dateTime.getHours() - 8)
                return {
                  ...record,
                  date: dateTime.toISOString().split("T")[0],
                  time: dateTime.toTimeString().split(" ")[0]
                }
              })
            }
 */
         
            
            
            setTotalRecords(response.data.count || response.data.results)
            try {
              setTableData ? setTableData(response.data) : null
            } catch (e) {
              console.log("ERROR", e)
            }
            if (response.data.total) {
              results.unshift({ id: "total", ...response.data.total })
            }
            setData(results)
            

            setLoading(false);
          }

          if (response.status === 202) {
            let results = mapData(response.data.results);
            setTotalRecords(response.data.count);
            if (response.data.total) {
              results.unshift({ id: "total", ...response.data.total });
            }
            setData(results);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log("errorbackend", error),

            setNotify({
              isOpen: true,
              message: error.response.data.message,
              type: "error",
            });
          setLoading(false);
          setData([]);
        });
    }
  };

  const outerFetchData = () => {
    setLoading(true);
    setDoPolling(true);
  };

  useInterval(
    async () => {
      const resp = await eightAxios.get(proxyURL, config);
      if (resp.status === 200) {
        setTotalRecords(resp.data.count);
        setData(resp.data.results);
        try {
          setTableData ? setTableData(resp.data) : null;
        } catch (e) {
          console.log("ERROR", e);
        }
        setLoading(false);
        setDoPolling(false);
      }

      if (resp.status === 202) {
        try {
          setTableData ? setTableData(resp.data) : null;
        } catch (e) {
          console.log("ERROR", e);
        }        
        setTotalRecords(resp.data.count);
        setData(resp.data.results);
        setLoading(false);
        setDoPolling(true);
      }
    },
    doPolling ? pollingInterval : null
  );
  const SendSms = (props) => {
    const { messageBody, setMessageBody } = props;
    return (
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <div>{messageBody}</div>
        </Grid>
        <Grid item>
          <TextField
            onChange={(event) => {
              setMessageBody(event.target.value);
            }}
            defaultValue={JSON.parse(localStorage.getItem('email'))}
            variant="outlined"
            row={5}
            multiline
            fullWidth
          />
        </Grid>
      </Grid>
    );
  };
  SendSms.propTypes = {
    messageBody: PropTypes.string,
    setMessageBody: PropTypes.func,
  };

  //This function is used for direct download the excel file
  const downloadCsv = (config) => {
    if (
      (!proxyURL || totalRecords <= 0 || (Array.isArray(totalRecords) && totalRecords.length === 0))
      && proxyURL !== WORKER_DETAILED_REPORT_URL
    ) {
      setNotify({
        isOpen: true,
        message: "No record, download not applicable.",
        type: "error",
      });
      return;
    }
    if (!proxyURL == WORKER_DETAILED_REPORT_URL && !proxyURL == BO_ACCESS_MOBILE_REPORT_URL && !proxyURL == BO_ACCESS_PORTAL_REPORT_URL) {
      setNotify({ isOpen: true, message: "No record, download not applicable.", type: "error" });
      return;
    }

    let params = {
      headers: { Accept: "application/xlsx" },
      responseType: "arraybuffer",
    };
    params = { ...config, ...params };
    if (proxyURL == WORKER_DETAILED_REPORT_URL || BO_ACCESS_MOBILE_REPORT_URL || BO_ACCESS_PORTAL_REPORT_URL || POLICY_DETAILS_URL) {
      params = { ...config, ...params, params: { ...params.params, fmt: "xlsx" } };

    } else {
      params = { ...config, ...params };
    }
    if (proxyURL == HQVIEW_URL) {
      params = { ...config, ...params, params: { ...params.params, fmt: "xlsx",hq:true } };

    } else {
      params = { ...config, ...params };
    }

    if (proxyURL == ATTENDANCE_BY_MONTH_URL) {
      params = { ...config, ...params };
      params.params.download_data = true;

    } else {
      params = { ...config, ...params };
    }
    eightAxios
      .get(proxyURL, params)
      /* .then((response) => {
        let fileName = excelExport.fileName ? `${excelExport.fileName}-${format(new Date(), "yyyy-MM-dd-HHmmss")}.xlsx`
          : "export.xlsx";
        FileDownload(response.data, fileName);
        setNotify({
          isOpen: true,
          message: "Successfully Exported",
          type: "success",
        });
      }) */
        .then((response) => {          
          let fileName = excelExport.fileName ? `${excelExport.fileName}-${format(new Date(), "yyyy-MM-dd-HHmmss")}.xlsx` : "export.xlsx"          
          function formatDate(date) {
            try {
              let formattedDate = date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
        
              let formattedTime = date.toLocaleTimeString("en-GB", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
                timeZone: 'Asia/Singapore',
              })
        
              
              formattedTime = formattedTime.replace('am', 'AM').replace('pm', 'PM')
        
              return formattedDate + ', ' + formattedTime
            } catch (e) {
              console.error("Error formatting date:", e)
              return date
            }
          }

          
          let workbook = XLSX.read(response.data, { type: "array" });

          
          workbook.SheetNames.forEach(sheetName => {
            let sheet = workbook.Sheets[sheetName]

            
            Object.keys(sheet).forEach(cellAddress => {
              let cell = sheet[cellAddress]             
              if (typeof cell.v === 'string' && (cell.v.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/))) {
                let dateValue = new Date(cell.v)
                let formattedDate = formatDate(dateValue)
                cell.v = formattedDate;
              }
            })
          })

         
          let excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" })

          FileDownload(excelBuffer, fileName)

         
          setNotify({
            isOpen: true,
            message: "Successfully Exported",
            type: "success",
          });
        })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        console.log(error);
      });
  };

  //this function is used to send the excel file in the particular email.
  const emailDownloadCsv = (config) => {
    if (!proxyURL || totalRecords <= 0 || Array.isArray(totalRecords) && totalRecords.length === 0) {

      setNotify({
        isOpen: true,
        message: "No record, download not applicable.",
        type: "error",
      });
      return;
    }
    var newparms = {
      params: {
        from_date: config.params.from_date,
        to_date: config.params.to_date,
        zone: config.params.zone,
        region: config.params.region,
        estate: config.params.estate,
        division: config.params.division,
        status: config.params.status,
        block: config.params.block,
        employee_id: config.params.employee_id,
        name: config.params.name,
        supervisor_id: config.params.supervisor_id,


      }
    }
    eightAxios
      .get(`${proxyURL}mail-record`, newparms)
      .then((response) => {

        setNotify({
          isOpen: true,
          message: response.data.message,
          type: "success",
        });
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
      });
  };

  //This function is used for direct download the pdf file
  const pdfDownloadCsv = (config) => {
    if (!proxyURL == WORKER_DETAILED_REPORT_URL && !proxyURL == BO_ACCESS_MOBILE_REPORT_URL && BO_ACCESS_PORTAL_REPORT_URL) {
      setNotify({ isOpen: true, message: "No record, download not applicable.", type: "error" });
      return;
    }
    
    if (
      (!proxyURL || totalRecords <= 0 || (Array.isArray(totalRecords) && totalRecords.length === 0))
      && proxyURL !== WORKER_DETAILED_REPORT_URL
    ) {
      setNotify({
        isOpen: true,
        message: "No record, download not applicable.",
        type: "error",
      });
      return;
    }
    let params = {
      responseType: "arraybuffer",
    };
    if (config && config.params) {
      params = { ...config, ...params };
      if (proxyURL == HQVIEW_URL) {
        params = { ...config, ...params, params: { ...params.params, fmt: "pdf",hq:true } };
  
      } else {
        params = { ...config, ...params };
      }
      if (proxyURL == WORKER_DETAILED_REPORT_URL || BO_ACCESS_MOBILE_REPORT_URL || BO_ACCESS_PORTAL_REPORT_URL) {
        params = { ...config, ...params, params: { ...params.params, fmt: "pdf" } };
      } else {
        params = { ...config, ...params };
      }
    }

   
      
      

      eightAxios
      .get(proxyURL, params)
      .then((response) => {
        //  let fileName = pdfExport.fileName ? `${pdfExport.fileName}-${format(new Date(), "yyyy-MM-dd-HHmmss")}.pdf` : "export.pdf";
        // FileDownload(response.data, fileName); 

    const decoder = new TextDecoder("utf-8");
    const jsonString = decoder.decode(response.data);

    // Parse String to JSON
    const responseData = JSON.parse(jsonString);

    const handleDownload = (data) => {

      const headers2 = Object.values(data?.columns || []);
      const tableData2= data?.data?.map((item) =>
        headers2.map((header) => item[header] || "")
      ) || [];    

      // const doc = new jsPDF();

      let doc;
      if (headers2.length > 9) {
        doc = new jsPDF("l", "mm", "a4")
      } else {
        doc = new jsPDF("p", "mm", "a4")
      } 
    
      // FGV HOLDINGS BERHAD text
      const companyName = /* data?.companyName || */ "FGV HOLDINGS BERHAD";
      doc.setFontSize(14);
      doc.text(
        companyName,
        doc.internal.pageSize.width / 2 - doc.getTextWidth(companyName) / 2,
        15
      );
    
      // Title
      const title = data?.title || "No Title Available";
      doc.setFontSize(16);
      doc.text(
        title,
        doc.internal.pageSize.width / 2 - doc.getTextWidth(title) / 2,
        25
      );
    
      // Header Meta
      const headerMeta = data?.header_meta || [];
      doc.setFontSize(10);
      let yOffset = 40; // Start after the title
      headerMeta.forEach((meta) => {
        if (Array.isArray(meta)) {
          const key = meta[0] || "Unknown Key";
          const value = meta[1] || "Unknown Value";
          doc.text(`${key}: ${value}`, 14, yOffset);
          yOffset += 6;
        } else if (meta) {
          doc.text(meta.toString(), 14, yOffset);
          yOffset += 6;
        }
      });

      yOffset -= 10;
    
      // Table
      const headers = Object.values(data?.columns || []);
      const tableData = data?.data?.map((item) =>
        headers.map((header) => item[header] || "")
      ) || [];
    
      const pageWidth = doc.internal.pageSize.width - 20; // account for margins 
      const columnWidth = pageWidth / headers.length;

      doc.autoTable({ 
        head: [headers], 
        body: tableData, 
        startY: yOffset + 10, 
        styles: {
          cellPadding: 5,
          fontSize: 7,
          // font: "Arial",
          halign: "left",
          valign: "middle",
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
          overflow: 'linebreak', // Prevent text from breaking
        },
        headStyles: {
          fillColor: "#FEF2CC",
          textColor: [0, 0, 0],
          fontStyle: "bold",
          lineColor: [0, 0, 0],
          fontSize: 7,
          cellPadding: 1, // Remove padding in table body cells
        },
        bodyStyles: {
          cellPadding: 1, // Remove padding in table body cells
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 7,
        },
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        columnStyles: headers.reduce((acc, _, index) => { acc[index] = { cellWidth: columnWidth }; return acc; }, {}),
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.2,
        margin: { top: 10, left: 10, right: 10 },
        pageBreak: 'auto', // Ensure rows are not split across pages
      });

     
      // Save the generated PDF
      doc.save(data?.filename || "export.pdf");
    };

    handleDownload(responseData);
        
      })
      .catch((error) => {
        // setNotify({ isOpen: true, message: error.response.data.message, type: "error" });
        console.log("error in download PDF", error);
        
      }); 
     
  };



  useEffect(() => {
    if (sorter) {
      let sortingKey = sorter.sortingKey;
      let sortingType = sorter.sortingType === "asc" ? "-" : "";
      console.log("sortingType", sortingKey)
      Object.assign(config.params, { ordering: sortingType + sortingKey });

    }
    if (polling) {
      outerFetchData();
    } else {
      fetchData(config);
    }
  }, [page, pageSize, filterValues, outerFetchTrigger, refresh, sorter]);

  if (!isObjectEmpty(onError)) {
    return (
      <Error
        code={onError.code}
        message={onError.message}
        sidebar={onError.sidebar}
      />
    );
  }

  if (!data) {
    return <LoadingIcon image text="Loading" />;
  }
  getActions();
  getFilters();
  getActionBarButtons();

  return (
    <div>
      <MyTable
        refreshData={outerFetchTrigger ? outerFetchData : fetchData}
        config={config}
        headCells={model}
        // View permission is being controlled here
        records={viewPermission || viewDetailsPermission ? data : []}
        tableButton={allActionBarButtons}
        setConfirmDialog={setConfirmDialog}
        setViewDialog={setViewDialog}
        actions={actions ? allActions : null}
        filters={allFilters}
        // Finally, download permission is being checked here
        emailExcelExport={
          downloadPermission
            ? emailExcelExport
              ? () => emailDownloadCsv(excelConfig)
              : undefined
            : false
        }
        pdfExport={
          downloadPermission
            ? pdfExport
              ? () => pdfDownloadCsv(excelConfig)
              : undefined
            : false
        }
        excelExport={
          downloadPermission
            ? excelExport
              ? () => downloadCsv(excelConfig)
              : undefined
            : false
        }
        disablePdfExport={
          downloadPermission
            ? disablePdfExport

            : false
        }
        disableExcelExport={
          downloadPermission
            ? disableExcelExport
            : false
        }
        infoContent={infoContent}
        showInfoIcon={showInfoIcon}
        pageNumberDropdown={pageNumberDropdown}
        paginationDisable={paginationDisable}
        tableBodyDisable={tableBodyDisable}
        grandTotalEnable={grandTotalEnable}
        disableLabelDisplayedRows = {disableLabelDisplayedRows}
        hideToolbar={hideToolbar}
        noData={noData}
        noAddButton={!addPermission}
        {...checkBoxArgs}
        loading={loading}
        setLoading={setLoading}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalRecords={totalRecords}
        linkUrlName={linkUrlName}
        viewPermission={viewPermission}
        viewDetailsPermission={viewDetailsPermission}
        editPermission={editPermission}
        sortingCallback={setSorter}
        shortTermMemory={shortTermMemory}
        setSelectedEmployeeId={setSelectedEmployeeId}
        setShortTermMemory={setShortTermMemory}
      />
      <Modal inputEmail={inputEmail} modalFields={modalFields} setModalFields={setModalFields} />


      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />

      <ViewDialog viewDialog={viewDialog} setViewDialog={setViewDialog} />
    </div>
  );
};


Table.propTypes = {
  proxyURL: PropTypes.string,
  model: PropTypes.array,
  actions: PropTypes.array,
  filters: PropTypes.object,
  emailExcelExport: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  pdfExport: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  excelExport: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  disablePdfExport: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  disableExcelExport: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  noFilter: PropTypes.bool,
  noAddButton: PropTypes.bool,
  actionBarButtons: PropTypes.arrayOf(object),
  check: PropTypes.bool,
  pageNumberDropdown: PropTypes.bool,
  paginationDisable: PropTypes.bool,
  grandTotalEnable: PropTypes.bool,
  hideToolbar: PropTypes.bool,
  selected: PropTypes.array,
  selectedEmployeeId: PropTypes.array,
  setSelected: PropTypes.func,
  setSelectedEmployeeId: PropTypes.func,
  filterValues: PropTypes.object,
  defaultFilterParams: PropTypes.object,
  isBackOffice: PropTypes.bool,
  polling: PropTypes.bool,
  noData: PropTypes.bool,
  outerFetchTrigger: PropTypes.number,
  linkUrlName: PropTypes.string,
  isUserDelete: PropTypes.bool,
  isBOUserDelete: PropTypes.bool,
  isRoleDelete: PropTypes.bool,
  isBannerDelete: PropTypes.bool,
  isShopDelete: PropTypes.bool,
isLanguageDelete: PropTypes.bool,
  refresh: PropTypes.bool,
  setTableData: PropTypes.func,
  downloadId: PropTypes.array,
  editPermission: PropTypes.bool,
  viewPermission: PropTypes.bool,
  viewDetailsPermission: PropTypes.bool,
  showInfoIcon: PropTypes.bool,
  infoContent: PropTypes.string,
  tableBodyDisable: PropTypes.bool,
  disableLabelDisplayedRows: PropTypes.bool,



};

export default Table;
